import { ignoreIfThrows } from '@wix/cashier-common/dist/src/utils/errorHandling';
import { filterDefined } from '../filterDefined';
import { type ErrorReportsParams } from '../../types/PayApp';
import { Panorama } from '../panorama';

export interface TrackErrorOptions {
  messagePrefix?: string;
  shouldRethrow?: boolean;
}

let errorReportParams: ErrorReportsParams | undefined;

export const trackError = (error: Error, params?: TrackErrorOptions) => {
  const { messagePrefix, shouldRethrow = false } = params || {};

  try {
    const errorTags = errorReportParams ? filterDefined(errorReportParams) : {};
    Panorama.client!.errorMonitor({
      data: {
        tags: errorTags,
        environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
        errorName: messagePrefix ? `${messagePrefix} - ${error.message}` : error.message,
      },
    }).reportError(error, {
      tags: errorTags,
    });
  } catch (e) {
    console.error(`Failed to exec captureError`, e);
  }

  console.error('Captured error:', error);

  if (shouldRethrow) {
    throw error;
  }
};

export const enrichErrorReports = ignoreIfThrows((params: ErrorReportsParams) => {
  errorReportParams = params;
});
